import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/blog.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/carousel.tsx");
